import createContext from '@ant-design/create-react-context';
var RowContext = createContext({});
export default RowContext;
//# sourceMappingURL=RowContext.js.map
